function cov_1e8ymkqpaw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Favorite.tsx";
  var hash = "15b3d37b900412fbb9eecff6f75feb230c3d0d1c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Favorite.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "15b3d37b900412fbb9eecff6f75feb230c3d0d1c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1e8ymkqpaw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1e8ymkqpaw();
var Icon = (cov_1e8ymkqpaw().s[0]++, {
  name: 'favorite',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.6683 4.71504C8.97314 1.80934 3.73781 2.65898 2.30961 6.78489C1.65977 8.6622 2.04594 10.7646 3.34536 12.2805L10.3396 20.4405C11.038 21.2553 12.2986 21.2553 12.997 20.4405L19.9913 12.2805C21.2907 10.7646 21.6769 8.66221 21.027 6.78489C19.5988 2.65898 14.3635 1.80934 11.6683 4.71504ZM10.4201 7.33065C9.33252 4.79297 5.60513 4.90717 4.67207 7.60267C4.30954 8.64998 4.52879 9.81973 5.2435 10.6536L11.6683 18.1492L18.0931 10.6536C18.8079 9.81973 19.0271 8.64998 18.6646 7.60267C17.7315 4.90717 14.0041 4.79297 12.9165 7.33065C12.4462 8.42808 10.8904 8.42808 10.4201 7.33065Z\" fill=\"currentColor\"/>"
});
export default Icon;